import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>

    <path
      fill="currentColor"
      d="M8.5 18.31L5.69 15.5l6.37-6.38H7.11V5.69h11.2v11.2h-3.42v-4.95z"
    />
  </svg>
);

const ArrowTopRightIcon = (props) => <Icon component={SVG} {...props} />;

export default ArrowTopRightIcon;
